var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16699 4.16667C3.70675 4.16667 3.33366 4.53976 3.33366 5V16.6667C3.33366 17.1269 3.70675 17.5 4.16699 17.5H15.8337C16.2939 17.5 16.667 17.1269 16.667 16.6667V5C16.667 4.53976 16.2939 4.16667 15.8337 4.16667H4.16699ZM1.66699 5C1.66699 3.61929 2.78628 2.5 4.16699 2.5H15.8337C17.2144 2.5 18.3337 3.61929 18.3337 5V16.6667C18.3337 18.0474 17.2144 19.1667 15.8337 19.1667H4.16699C2.78628 19.1667 1.66699 18.0474 1.66699 16.6667V5Z",
    fill: "#82858D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 0.833313C13.7936 0.833313 14.1667 1.20641 14.1667 1.66665V4.99998C14.1667 5.46022 13.7936 5.83331 13.3333 5.83331C12.8731 5.83331 12.5 5.46022 12.5 4.99998V1.66665C12.5 1.20641 12.8731 0.833313 13.3333 0.833313Z",
    fill: "#82858D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66634 0.833313C7.12658 0.833313 7.49967 1.20641 7.49967 1.66665V4.99998C7.49967 5.46022 7.12658 5.83331 6.66634 5.83331C6.2061 5.83331 5.83301 5.46022 5.83301 4.99998V1.66665C5.83301 1.20641 6.2061 0.833313 6.66634 0.833313Z",
    fill: "#82858D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 8.33333C1.66699 7.8731 2.04009 7.5 2.50033 7.5H17.5003C17.9606 7.5 18.3337 7.8731 18.3337 8.33333C18.3337 8.79357 17.9606 9.16667 17.5003 9.16667H2.50033C2.04009 9.16667 1.66699 8.79357 1.66699 8.33333Z",
    fill: "#82858D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.b5bcc966b9371b673e8a596c332203b9.svg";
export { ForwardRef as ReactComponent };